/*
  Groessen-Leiste auf dem Handy einklappen.

  Warum: 31 Groessen plus "Alle Groessen" ergeben auf 390px acht Reihen und
  rund 470px Hoehe. Damit steht auf Startseite und Kollektionsseite im ersten
  Bildschirm kein einziges Produkt. Eingeklappt sind drei Reihen sichtbar,
  der Rest kommt per Tipp.

  Eingeklappt beginnt die Leiste bei EU 42 (AB_GROESSE): das sind die
  Groessen, die am meisten verkauft werden. Kleinere Groessen sind nicht weg,
  sie erscheinen mit "Alle Groessen anzeigen" an ihrer normalen Stelle.
  Die Reihenfolge wird nie veraendert.

  Gemerkte Groesse (.is-mine, setzt rb-size.js aus dem Speicher des Handys):
  Sie ist KEIN Grund, aufgeklappt zu starten - sonst sieht jeder, der einmal
  eine Groesse angetippt hat, fuer immer die volle Liste ab 36. Liegt die
  gemerkte Groesse unter 42, bleibt nur sie zusaetzlich sichtbar.

  Aktiver Filter (.is-active, Kollektionsseite mit gewaehlter Groesse):
  Startet offen, damit die aktive Auswahl sichtbar ist.

  Nur Handy (<= 749px). Auf dem Desktop bleibt alles wie es ist.
*/
(function () {
  var MAX = 749;
  var REIHEN = 3;
  var AB_GROESSE = 42;
  var KLEIN = 'rb-chips__li--klein';

  function text(auf, offen) {
    var de = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('de') === 0;
    if (offen) return de ? 'Weniger anzeigen' : 'Show fewer';
    return de ? 'Alle Größen anzeigen' : 'Show all sizes';
  }

  // Ganzzahliger Teil der Groesse aus dem Chip-Label ("42 2/3" -> 42, "42.5" -> 42).
  function groesse(li) {
    var a = li.querySelector('.rb-chip');
    if (!a || a.classList.contains('rb-chip--all')) return null;
    var s = (a.getAttribute('data-rb-size') || a.textContent || '').trim();
    var n = parseInt(s, 10);
    return isNaN(n) ? null : n;
  }

  function markiereKleine(liste) {
    var lis = liste.querySelectorAll('li');
    for (var i = 0; i < lis.length; i++) {
      var g = groesse(lis[i]);
      var a = lis[i].querySelector('.rb-chip');
      var gemerkt = !!(a && (a.classList.contains('is-mine') || a.classList.contains('is-active')));
      lis[i].classList.toggle(KLEIN, g !== null && g < AB_GROESSE && !gemerkt);
    }
  }

  function baue(liste) {
    if (liste.dataset.rbToggle) return;
    liste.dataset.rbToggle = '1';
    markiereKleine(liste);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rb-chips__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', liste.id || '');
    liste.parentNode.insertBefore(btn, liste.nextSibling);

    function hoehe() {
      var erste = liste.querySelector('li');
      if (!erste) return 0;
      var h = erste.getBoundingClientRect().height;
      var stil = window.getComputedStyle(liste);
      var gap = parseFloat(stil.rowGap || stil.gap || '0') || 0;
      return REIHEN * h + (REIHEN - 1) * gap;
    }

    function aus() {
      liste.classList.remove('rb-chips--collapsed');
      liste.classList.remove('is-open');
      liste.style.maxHeight = '';
      btn.hidden = true;
    }

    function an(offen) {
      liste.classList.add('rb-chips--collapsed');
      liste.classList.toggle('is-open', offen);
      liste.style.maxHeight = offen ? '' : hoehe() + 'px';
      btn.hidden = false;
      btn.textContent = text(liste, offen);
      btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
    }

    // Nur ein aktiver Filter (Kollektionsseite) startet offen - NICHT die
    // gemerkte Groesse, siehe Kommentar oben.
    var aktiv = !!liste.querySelector('.rb-chip.is-active:not(.rb-chip--all)');
    var offen = aktiv;

    function pruefe() {
      if (window.innerWidth > MAX) { aus(); return; }
      var erste = liste.querySelector('li');
      if (!erste) return;
      markiereKleine(liste);
      an(offen);
    }

    btn.addEventListener('click', function () {
      offen = !offen;
      an(offen);
      if (!offen) liste.scrollIntoView({ block: 'nearest' });
    });

    pruefe();
    // rb-size.js setzt .is-mine evtl. erst nach uns - dann einmal nachziehen.
    setTimeout(pruefe, 300);
    window.addEventListener('resize', pruefe);
    window.addEventListener('load', pruefe);
  }

  function init() {
    var listen = document.querySelectorAll('.rb-size-entry .rb-chips, .rb-size-bar .rb-chips');
    for (var i = 0; i < listen.length; i++) baue(listen[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();